export default "__VITE_ASSET__ieWg2fBs__"